<template>
  <div class="changeStatus">
    <section>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        style="padding-bottom: 50px;"
        class="demo-ruleForm"
      >
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 绑定密码：
          </div>
          <el-form-item class="input_right" prop="pwd">
            <el-input placeholder="请输入绑定密码"  v-model="form.pwd" type="password"/>
          </el-form-item>
        </li>
        <li>
<!--          <span class="redText" style="font-size: 10px">初始密码为身份证后6位</span>-->
        </li>
      </el-form>
      <button class="btn_bx" type='button' @click.stop="changeStatus">
        确 认 绑 定
      </button>
    </section>
  </div>
</template>

<script>
  import {bindUser} from "@/api";

  export default {
    data() {
      return {
        value: [],
        options: [],
        form: {},
        rules: {
          pwd: [
            {
              required: true, message: '必填'
            },
            {
              required: true, max: 6,min:6,message: '请输入6位',trigger:'blur'
            }
          ],
        },
      };
    },
    mounted() {

    },
    methods: {
      changeStatus() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.$route.query))
            delete data.idNumber
            delete data.pwd
            if(this.$route.query.pwd) {
              if(this.form.pwd==this.$route.query.pwd) {
                bindUser(data).then(res => {
                  this.$router.push(sessionStorage.getItem('path'))
                })
              } else {
                this.$toast('密码不正确')
              }
            } else {
              let idNumber = this.$route.query.idNumber
              let str = idNumber.substr(12 ,6)
              if(this.form.pwd==str) {
                bindUser(data).then(res => {
                  this.$router.push(sessionStorage.getItem('path'))
                })
              } else {
                this.$toast('密码不正确')
              }
            }
          }

        })

      },
    }
    ,
  }
  ;
</script>

<style>
  .changeStatus {
    padding: 3%;
    min-height: 90%;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 90%;
  }
  .yzmBtn{
    border: 1px solid #C2E7B0;
    border-radius: 3px;
    line-height: 26px;
    background: #F0F9EB;
    color: #67C23A;
    font-size: 12px;
    /*background: #000;*/
  }
  .xy{
    background: #fff;
    height: 80vh;
    width: 90%;
    border-radius: 5px;
    overflow-y: auto;
    /*margin-left: 5%;*/
    padding: 5px;
  }
  .changeStatus .mint-cell-wrapper {
    font-size: 14px !important;
  }

  .changeStatus .buleText {
    color: #1E88C7;
    font-size: 12px;
  }

  .changeStatus v.mask {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .4);
  }

  .changeStatus .btn_bx {
    width: 100%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }

  header, footer {
    height: 60px;
    line-height: 60px;

    /*text-align:center;*/
  }

  header {
    margin-bottom: 5px;
    background-color: #fff;

  }

  section {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    overflow: auto; /* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .sfzsl {
    width: 90%;
    height: 80vh;
    left: 5%;
    border-radius: 10px;
    position: absolute;
  }

  .redText {
    color: red;
  }

  .lable_left {
    width: 100px;
    color: black;
  }

  .flex_input {
    display: flex;
    line-height: 40px;
  }

  .changeStatus li {
    line-height: 40px;
    display: flex;
    border-bottom: 1px solid #F7F6F7;
  }

  .li_flex {
    justify-content: space-between;
  }

  .lable_right {
    color: #949393;
  }

  .greyText {
    color: #8c939d;
    margin-right: 10px;
  }

  .input_right {
    flex: 1;
    color: black;
  }

  .changeStatus .el-input__inner {
    padding: 0 !important;
  }

  .changeStatus .input_right input, .input_right textarea {
    border: none;
    outline: none;
    float: 1;
    margin-top: 5px;
  }

  .changeStatus .el-form-item {
    margin-bottom: 0 !important;
  }

  .itemList {
    /* border-bottom: 1px solid #fcfcfc; */
    color: #646262;
    /* padding-left: 8%; */
  }

  /*.mint-cell-wrapper {*/
  /*  padding: 0 !important;*/
  /*}*/
  .item {
    /* border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px; */
  }

  .uploader-file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .uploader-file:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    margin-top: 25px;
  }

  .file {
    width: 90%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
  }

  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }

  .file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
  }

  .imgDiv {
    position: relative;
  }

  .error_icon {
    position: absolute;
    font-size: 25px;
    right: 0px;
    top: 0px;
    z-index: 999999;
    color: #f00;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/wsfz/jymm.vue